import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/app/store/store';
import type { Permission, User, UserRole } from '@/entities/user/types';

export const selectAuthState = (s: RootState): RootState['auth'] => s.auth;

export const selectCurrentUser = (s: RootState): User | null => s.auth.user;

export const selectAccessToken = (s: RootState): string | null => s.auth.accessToken;

export const selectAuthStatus = (s: RootState): RootState['auth']['status'] =>
  s.auth.status;

export const selectIsAuthenticated = (s: RootState): boolean =>
  s.auth.status === 'authenticated';

export const selectIsAuthLoading = (s: RootState): boolean =>
  s.auth.status === 'idle' || s.auth.status === 'authenticating';

export const selectScopes = createSelector(
  [selectCurrentUser],
  (user): readonly Permission[] => user?.scopes ?? [],
);

export const selectUserRole = (s: RootState): UserRole | null =>
  s.auth.user?.role ?? null;

export const selectUserBranchId = (s: RootState): string | null =>
  s.auth.user?.branchId ?? null;
